import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Section,
  Step,
  Warning,
} from '../../components/DocsComponents'

const EventCostsAndExpenses = () => (
  <Page
    title="Event Costs and Expenses"
    intro="The Costs tab of the Planning workspace estimates what an event is really costing — staff, vehicles, consumables, and ad-hoc expenses — and compares it with what's been invoiced to show the margin."
  >
    <Section title="The cost breakdown">
      <Bullets>
        <Bullet>
          Six cards summarise the picture: <strong>Staff Cost</strong> (pay
          due on filled shifts, including any fixed shift bonuses),{' '}
          <strong>Vehicle Cost</strong> (estimated per
          deployment), <strong>Consumables</strong> (stock used, where items
          match the Stock Catalog), <strong>Other Expenses</strong>,{' '}
          <strong>Total Cost</strong>, and <strong>Margin</strong> against
          the event's invoices — green at 20%+ margin, orange when thin, red
          when loss-making.
        </Bullet>
        <Bullet>
          The <strong>Vehicle Cost Detail</strong> box shows each vehicle's
          days and daily rate; a "default rate" chip flags vehicles with no
          service history yet, which fall back to your tenant's default daily
          cost.
        </Bullet>
      </Bullets>
      <Info title="Estimates, not accounts">
        These figures are best-effort estimates rather than exact accounting —
        vehicle costs derive from real service history where available, and
        consumables only cover items matched to the Stock Catalog.
      </Info>
    </Section>

    <Section title="Recording an event expense">
      <Step number="1" title="Add the expense">
        Click <strong>Add Expense</strong> and fill in the date, a category
        (Venue, Equipment, Logistics, Subsistence, or Other), the amount, and
        a description. A receipt (PDF or image) can be attached.
      </Step>
      <Step number="2" title="Await approval">
        New expenses sit as <strong>Pending</strong>. Approve, Reject, and
        Delete actions appear on pending rows; approved and rejected expenses
        are locked in.
      </Step>
      <Warning title="Approval is a Finance action">
        Anyone with Event Planning access can record or delete a pending
        expense, but approving or rejecting one needs the{' '}
        <strong>Finance</strong> team — the buttons are visible to planners
        but the change will be refused without Finance access.
      </Warning>
    </Section>
  </Page>
)

export default EventCostsAndExpenses
